var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg37(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#98A3B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 6.08 9.92 8 6.8 9.92V6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73 2.86a2.91 2.91 0 0 0-2.6-2.59 48.42 48.42 0 0 0-10.26 0 2.91 2.91 0 0 0-2.6 2.6 48.42 48.42 0 0 0 0 10.26 2.91 2.91 0 0 0 2.6 2.6c3.4.36 6.85.36 10.26 0a2.91 2.91 0 0 0 2.6-2.6c.36-3.4.36-6.85 0-10.27Zm-2.96 7.55c-.2.61-.86.98-1.47 1.07-2.2.23-4.4.23-6.6 0-.6-.09-1.27-.45-1.47-1.07a12.5 12.5 0 0 1 0-4.82c.2-.61.87-.98 1.48-1.07 2.19-.23 4.4-.23 6.59 0 .6.09 1.27.46 1.47 1.07a12.5 12.5 0 0 1 0 4.82Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg37);
export default __webpack_public_path__ + "static/media/svg37.721a3cb6329e33f1f6c6b6b95d3a287a.svg";
export { ForwardRef as ReactComponent };